import {
  SET_LOGIN_TEXT,
} from '../actions/constants';

const loginHelpText = (state = null, action) => {
  switch (action.type) {
    case SET_LOGIN_TEXT:
      return action.payload == null ? state : action.payload;
    default:
      return state;
  }
};

export default loginHelpText;
